export default __webpack_public_path__ + "static/media/thumbnail-mobile-06.d0125450.png";